module.exports = __webpack_public_path__ + "img/win-minimize.1e9144e8.svg";